import { render } from "./CopyrightView.vue?vue&type=template&id=0318dcc3&scoped=true"
const script = {}

import "./CopyrightView.vue?vue&type=style&index=0&id=0318dcc3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lumaa.fr/lumaa.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0318dcc3"]])

export default __exports__